import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import ImageFadeIn from "react-image-fade-in";
import { Icon, Button } from "semantic-ui-react";

function ProgramCard({
  event,
  width,
  height,
  onClick,
}) {
  const storage = useSelector((state) => state.storage);

  const addToCalendar = (p) => {
    const GOOGLE_DATE_FORMAT = "YYYYMMDDTHHmmSS";

    const title = p.title.replace(' ', '+');
    const detail = encodeURI(p.detail);
    const address = p.address ? p.address.replace(' ', '+') : "";
    
    const startDateRaw = p.startDate?.toDate ? p.startDate.toDate() : p.startDate;
    const endDateRaw = p.endDate?.toDate ? p.endDate.toDate() : p.endDate;

    const startDate = moment(startDateRaw).format(GOOGLE_DATE_FORMAT);
    const endDate = moment(endDateRaw).format(GOOGLE_DATE_FORMAT);

    const googleCalendarUrl = 'https://calendar.google.com/calendar/u/0/r/eventedit';
    const googleCalendarOptions = `?text=${title}&dates=${startDate}/${endDate}&location=${address}&trp=false&details=${detail}&sf=true`;
    window.open(googleCalendarUrl + googleCalendarOptions);
  };

  const startDateRaw = event.startDate?.toDate ? event.startDate.toDate() : event.startDate;

  return (
    <div className="program-card" style={{ height }} onClick={onClick}>
      <div className="program-card-text">
        <div className="title">{event.title}</div>
        <div className="subtitle">
          <Icon name="calendar alternate outline" />
          {moment(startDateRaw).format("MMM DD, YYYY (ddd)")}
        </div>
        {event.location || event.room ? (
          <div className="location">
            <Icon name="map pin" />
            {`${event.location ? event.location : ""}${
              event.room ? `${event.location ? "-" : ""}${event.room}` : ""
            }`}
          </div>
        ) : null}
        <div className="detail">{`${event.detail}`}</div>
        <Button primary onClick={(e) => {
          addToCalendar(event);
          e.stopPropagation();
        }}>
          <Icon name="calendar alternate" /> Add To Calendar
        </Button>
      </div>
      <div className="program-card-image">
        {event.imageRef && storage[event.imageRef] ? (
          <ImageFadeIn
            src={storage[event.imageRef]}
            height={height}
            width={width}
          />
        ) : (
          <Skeleton height={height} width={width} />
        )}
      </div>
    </div>
  );
}

ProgramCard.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  event: PropTypes.object,
};

export default ProgramCard;
